import React, { lazy, Suspense } from 'react';
import Loader from '../../components/Loader/Loader.lazy';

const LazyNotificationHome = lazy(() => import('./NotificationHome'));

const NotificationHome = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyNotificationHome {...props} />
  </Suspense>
);

export default NotificationHome;
